import React from "react";
import TextInput from "./TextInput";
import { TextInputProps } from "./types";

interface PasswordInputProps
  extends Omit<TextInputProps, "value" | "onChange"> {
  value: string;
  onChange: (value: string) => void;
}

const PasswordInput: React.FC<PasswordInputProps> = ({
  value,
  onChange,
  placeholder,
  label,
  ...rest
}) => {
  return (
    <TextInput
      label={label}
      type="password"
      value={value}
      onChange={(value: string | number) => onChange(value as string)}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default PasswordInput;
